module.exports = __webpack_public_path__ + "static/media/health-program_p4_3.d8bdf224.png";